module.exports = __webpack_public_path__ + "img/福.49dfa751.png";